/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Injectable } from '@angular/core';
import { FeatureFlagManager } from './FeatureFlagManager';
import { externalAngulars } from '../plain-javascript/services/ExternalAngulars';

/**
 * This class exist as a hook into the angular world for [[ExternalAngular]], is responsible for registering services onto it.
 * Doesn't do anything until start is called, currently managed by [[AppComponent]]
 */
@Injectable()
export class AngularExporter {
	constructor(private featureFlagManager: FeatureFlagManager) {}

	public start() {
		externalAngulars.init(this.featureFlagManager);
	}
}
